var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loadingModal"},[_c('el-progress',{style:({top: '35%'}),attrs:{"type":_vm.type,"colors":_vm.colors,"percentage":_vm.percentage,"status":_vm.percentage === 100 ? 'success':undefined}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }